import { transformConstants } from 'helpers/transformConstants';

const inventoryTransferConstants = transformConstants([
  'MOKAPOS_INVENTORY_TRANSFER_CREATE',
]);

export { inventoryTransferConstants };
